<template>
    <div class="content">
      <el-card>
          <el-form
              class="form_pad"
              ref="formPad"
              :inline="true"
              :model="listQuery"
              >
              <el-row class="clear_fix">
                <el-form-item :label="$t('reconciliation.placementMonth')">
                  <el-date-picker
                    class="settle_picker"
                    clearable
                    v-model="listQuery.months"
                    type="months"
                    style="width: 300px;min-width: 30px;"
                    format="yyyy 年 M 月"
                    value-format="yyyy-M"
                    placeholder="选择月份">
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('reconciliation.templateName')">
                  <el-select
                    v-model="listQuery.template_id"
                    filterable
                    style="width: 200px"
                    :placeholder="$t('common.selectTemplate')"
                  >
                    <el-option
                      v-for="item in $com.templateList"
                      :key="item.template_id"
                      :label="$i18n.locale == 'zh'?item.name + '-' + item.template_id : item.en_name + '-' + item.template_id"
                      :value="item.template_id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('reconciliation.adZone')">
                  <el-select
                    v-model="listQuery.media_ad_slot"
                    clearable
                    filterable
                    style="width: 200px"
                    :placeholder="$t('common.select')"
                  >
                    <el-option
                      v-for="item in adList"
                      :key="item.id"
                      :label="item.name+'【'+ item.ad_zone_id +'】'"
                      :value="item.ad_zone_id"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row class="search-btns">
                  <el-button type="primary" icon="el-icon-search" @click="getMonthStatsList">{{$t('common.search')}}</el-button>
              </el-row>
          </el-form>
      </el-card>
      <el-card>
          <div class="table-container">
            <div>
              <div class="download drawer_line clear_fix">
                {{$t('reconciliation.summaryReport')}}
                <div class="btn_style" style="float:right">
                  <span class="fred">
                    {{$t('reconciliation.downloadTip')}}
                  </span>
                  <el-button type="primary" size="mini" @click="downloadBill()" :disabled="downloadDisabled">
                    <Icon name="export" class="svg-icon exportIcon"/>
                    {{$t('reconciliation.batchDownloadBill')}}
                  </el-button>
                </div>
              </div>
            </div>
            <el-table v-if="tableList && tableList.length > 0" :data="tableList" class="table" v-loading="listLoading">
              <el-table-column :label="$t('reconciliation.placementMonth')" align="center">
                <template slot-scope="scope">{{ scope.row.month | formatMonth}}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.rawReq')" align="center">
                <template slot-scope="scope">{{ scope.row.raw_req | commafyFilter}}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.bid')" align="center">
                <template slot-scope="scope">{{ scope.row.bid | commafyFilter}}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.exposure')" align="center">
                <template slot-scope="scope">{{ scope.row.imp | commafyFilter}}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.exposureRate')" align="center">
                <template slot-scope="scope">{{ scope.row.imp_rate }}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.click')" align="center">
                <template slot-scope="scope">{{ scope.row.clk | commafyFilter}}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.clickRate')" align="center">
                <template slot-scope="scope">{{ scope.row.clk_rate }}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.CPM')" align="center">
                <template slot-scope="scope">{{ scope.row.cpm }}</template>
              </el-table-column>
              <el-table-column :label="$t('reconciliation.profit')" align="center">
                <template slot-scope="scope">{{ scope.row.media_price}}</template>
              </el-table-column>
              <el-table-column :label="$t('table.operation')">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="downloadBill(scope.row)">{{$t('reconciliation.downloadBill')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="nodata">
                <img src="../../../assets/img/nodata.png" class="nodata_img">
                <p class="nodata_text">暂无数据</p>
            </div>
          </div>
      </el-card>
      <!-- 生成对账单 -->
      <el-dialog
      class="reconciliation"
      :title="$t('reconciliation.generateReconciliation')"
      :visible.sync="reconciliationVisible"
      :before-close="handleReconciliationClose"
      width="500px"
    >
      <el-form
      class="pl50"
      ref="reconciliationForm"
      label-width="118px"
      :model="formData"
      :rules="formRules"
      >
        <el-form-item :label="$t('reconciliation.taxRate')" prop="taxRate">
          <el-select
            v-model="formData.taxRate"
            filterable
            style="width: 250px"
            :placeholder="$t('common.select')"
          >
          <el-option label="6%" value="6%"></el-option>
          <el-option label="3%" value="3%"></el-option>
          <el-option label="1%" value="1%"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('reconciliation.companyName')" prop="companyName">
          <el-input
            v-model="formData.companyName"
            :placeholder="$t('reconciliation.companyNamePlaceholder')"
            style="width: 250px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reconciliationVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" :loading="exportLoading" @click="confirmDownloadBill">{{$t('reconciliation.confirmDownloadBill')}}</el-button>
      </div>
    </el-dialog>
    </div>
</template>
<script>
import util from '@/utils/util'
import LAY_EXCEL from 'lay-excel'
const formDataDefault =  {
  taxRate: "6%",
  companyName: ''
}
export default {
  data() {
    return {
      listLoading: false,
      reconciliationVisible: false,
      exportLoading: false,
      downloadDisabled: true,
      listQuery: {
        months: [],
        template_id: 0,
        media_ad_slot: ""
      },
      formData: Object.assign({}, formDataDefault),
      currentRow: null,
      tableList: [],
      adList: [],
      formRules: {
        companyName: [
          { required: true, message: this.$t('reconciliation.companyNameCheck'), trigger: "blur" },
        ]
      },
    }
  },
  computed:{
  },
  filters: {
    commafyFilter(val) {
      return util.commafy(val)
    },
    formatMonth(month) {
      const monthStr = month.toString()
      const year = monthStr.substring(0, 4)
      const monthNum = parseInt(monthStr.substring(4))
      return `${year}年 ${monthNum}月`
    }
  },
  created() {
    this.getMonth()
    this.getAdlist()
  },
  mounted() {
  },
  methods: {
    getMonth() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      this.listQuery.months = [year + '-' + month]
    },
    getMonthStatsList() {
      this.listLoading = true
      let params = {...this.listQuery}
      if(!params.months) {
        this.$message.error(this.$t('reconciliation.monthsCheck'))
        this.listLoading = false
        return
      }
      params.months = params.months.map(item => {
        const [year, monthStr] = item.split('-')
        const month = monthStr.padStart(2, '0')
        return Number(year + month)
      })
      this.__postData('getMonthStatsList', params, (res) => {
        if(res.code == 1) {
          this.$message.error(res.msg);
        } else {
          this.listLoading = false
          this.tableList = res.list
          if(!this.tableList.length) {
            this.$message.error(this.$t('message.listEmpty'))
            return
          }
          this.downloadDisabled = false
        }
      })
    },
    getAdlist() {
      this.__getData('getAdListAll', null, (res) => {
        this.adList = res
      })
    },
    handleReconciliationClose() {
      this.$nextTick(() => {
        this.$refs.reconciliationForm.resetFields()
        this.formData = Object.assign({}, formDataDefault)
      })
      this.reconciliationVisible = false
      this.currentRow = null
    },
    downloadBill(row) {
      this.reconciliationVisible = true
      this.currentRow = row ? row : null 
      this.$nextTick(() => {
        this.$refs.reconciliationForm.resetFields()
        this.formData = Object.assign({}, formDataDefault)
      })
    },
    confirmDownloadBill() {
      this.$refs.reconciliationForm.validate((valid) => {
        if (valid) {
          this.exportLoading = true
          if(this.currentRow) {
            this.exportData([this.currentRow])
          }else {
            this.exportData(this.tableList)
          }
          this.exportLoading = false
          this.reconciliationVisible = false
        }else {
          this.$message.error(this.$t('message.completeForm'))
        }
      })
    },
    exportData(list) {
      const headers = ['年度', '投放月份', '投放类型', '消耗金额', '开票税率', '结算金额', '不含税金额', '增值税']
      const taxRateStr = this.formData.taxRate
      const taxRateNum = parseFloat(taxRateStr) / 100
      const companyName = this.formData.companyName
      const partyA = {
              companyName: '多盟智胜网络技术(北京)有限公司',
              taxNo: '91110108562113330W',
              address: '北京市朝阳区酒仙桥北路9号(厂区)10幢二层B7-08',
              phone: '010-56478104',
              bankName: '招商银行北京阜外大街支行',
              bankAccount: '110934605010103'
            }
      const tableData = list.map(item => {
        const monthStr = item.month.toString()
        const year = monthStr.substring(0, 4)
        const month = monthStr.substring(4).padStart(2, '0') + '月'

        const consumeAmount = item.media_price
        const baseDiff = 0.06 - taxRateNum
        const settlementAmount = consumeAmount * (1 - (baseDiff + baseDiff * 0.12))
        const taxExclusiveAmount = settlementAmount / (1 + taxRateNum)
        const taxAmount = settlementAmount - taxExclusiveAmount

        return [
          year,
          month,
          '程序化',
          consumeAmount,
          taxRateStr,
          settlementAmount.toFixed(2),
          taxExclusiveAmount.toFixed(2),
          taxAmount.toFixed(2)
        ]
      })
      const totalSettlement = tableData.reduce((sum, r) => sum + parseFloat(r[5]), 0).toFixed(2)
      const totalTaxExclusive = tableData.reduce((sum, r) => sum + parseFloat(r[6]), 0).toFixed(2)
      const totalTax = tableData.reduce((sum, r) => sum + parseFloat(r[7]), 0).toFixed(2)

      // 构建 Excel 数据
      const excelData = []
      excelData.push([`多盟&${companyName}对账单`, '', '', '', '', '', '', ''])
      excelData.push(headers)
      tableData.forEach(row => excelData.push(row)) 
      excelData.push(['', '', '', '', '合计金额', totalSettlement, totalTaxExclusive, totalTax]) 

      // 甲方开票信息
      const partyAInfo = [
        `公司名称: ${partyA.companyName}`,
        `税号: ${partyA.taxNo}`,
        `地址: ${partyA.address}`,
        `电话: ${partyA.phone}`,
        `开户行: ${partyA.bankName}`,
        `账号: ${partyA.bankAccount}`
      ].join('\n')
      excelData.push(['甲方开票信息', partyAInfo, '', '', '', '', '', '']) 
      excelData.push(['', '', '', '', '', '', '', '']) 
      excelData.push(['', '', '', '', '', '', '', '']) 
      excelData.push(['', '', '', '', '', '', '', '']) 

      // 盖章区域
      excelData.push([
        '甲方：多盟智胜网络技术(北京)有限公司', '', '', '', 
        '乙方：' + companyName, '', '', ''
      ])
      excelData.push([
        '(盖章)', '', '', '', 
        '(盖章)', '', '', ''
      ])
      excelData.push(['', '', '', '', '', '', '', ''])

      excelData.push(['针对于账单模板下载,数据仅供参考,实际结算以对账邮件为准', '', '', '', '', '', '', ''])

      // 合并单元格
      const totalRowIndex = 2 + tableData.length  
      const partyAStartRow = totalRowIndex + 1   
      const partyAEndRow = partyAStartRow + 3     
      // 盖章区域99
      const sealStartRow = partyAEndRow + 1      
      const sealEndRow = sealStartRow + 2       
      const merges = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, 
        { s: { r: excelData.length - 1, c: 0 }, e: { r: excelData.length - 1, c: 7 } }, 
        { s: { r: totalRowIndex, c: 0 }, e: { r: totalRowIndex, c: 3 } }, 
        { s: { r: partyAStartRow, c: 0 }, e: { r: partyAEndRow, c: 0 } }, 
        { s: { r: partyAStartRow, c: 1 }, e: { r: partyAEndRow, c: 7 } },
        { s: { r: sealStartRow, c: 0 }, e: { r: sealEndRow, c: 7 } },     
        { s: { r: sealStartRow, c: 0 }, e: { r: sealStartRow, c: 3 } }, 
        { s: { r: sealStartRow, c: 4 }, e: { r: sealStartRow, c: 7 } },  
        { s: { r: sealStartRow + 1, c: 0 }, e: { r: sealStartRow + 1, c: 3 } }, 
        { s: { r: sealStartRow + 1, c: 4 }, e: { r: sealStartRow + 1, c: 7 } }
      ]

      // 标题样式
      LAY_EXCEL.setExportCellStyle(excelData, 'A1:H1', {
        s: {
          alignment: { horizontal: 'center', vertical: 'center' },
          font: { bold: true, sz: 16 }
        }
      })

      // 表头样式
      LAY_EXCEL.setExportCellStyle(excelData, 'A2:H2', {
        s: {
          fill: { fgColor: { rgb: "d4e4f5" } },
          alignment: { horizontal: 'center', vertical: 'center' },
          font: { bold: true }
        }
      })

      // 数据行居中
      const dataStartRow = 3
      const dataEndRow = 2 + tableData.length
      LAY_EXCEL.setExportCellStyle(excelData, `A${dataStartRow}:H${dataEndRow}`, {
        s: {
          alignment: { horizontal: 'center', vertical: 'center' }
        }
      })

      // 合计行
      LAY_EXCEL.setExportCellStyle(excelData, `E${totalRowIndex + 1}:H${totalRowIndex + 1}`, { 
        s: { 
          alignment: { horizontal: 'center', vertical: 'center' },
          font: { bold: true }  
        }
      })

      // 甲方信息样式
      LAY_EXCEL.setExportCellStyle(excelData, `A${partyAStartRow + 1}:A${partyAEndRow + 1}`, {
        s: { 
          alignment: { horizontal: 'left', vertical: 'center' },
          font: { bold: true }  
        }
      })
      LAY_EXCEL.setExportCellStyle(excelData, `B${partyAStartRow + 1}:H${partyAEndRow + 1}`, {
        s: { 
          alignment: { horizontal: 'left', vertical: 'top', wrapText: true }
        }
      })

      // 盖章样式
      LAY_EXCEL.setExportCellStyle(excelData, `A${sealStartRow}:H${sealEndRow}`, {
        s: { 
          alignment: { horizontal: 'center', vertical: 'center' },
          font: { bold: true },
          border: { 
            top: { style: 'thick', color: { rgb: '000000' } },
            bottom: { style: 'thick', color: { rgb: '000000' } },
            left: { style: 'thick', color: { rgb: '000000' } },
            right: { style: 'thick', color: { rgb: '000000' } }
          }
        }
      })

      LAY_EXCEL.setExportCellStyle(excelData, `A${excelData.length}:H${excelData.length}`, {
        s: {
          font: { color: { rgb: "FF0000" } },
          alignment: { horizontal: 'center' }
        }
      })
      const borderStyle = {
        style: 'thin',
        color: { rgb: '000000' }
      }
      const allBorder = {
        top: borderStyle,
        bottom: borderStyle,
        left: borderStyle,
        right: borderStyle
      }
      LAY_EXCEL.setExportCellStyle(excelData, `A1:H${excelData.length}`, {
        s: { border: allBorder }
      })


      const colWidths = LAY_EXCEL.makeColConfig({
        A: 90, B: 90, C: 90, D: 100,
        E: 90, F: 100, G: 100, H: 90
      })
      const rowHeights = Array(excelData.length).fill({ hpx: 25 }) 
      rowHeights[0] = { hpx: 40 } 
      rowHeights[1] = { hpx: 30 } 
      rowHeights[sealStartRow] = { hpx: 30 }   
      rowHeights[sealStartRow + 1] = { hpx: 30 } 
      rowHeights[sealStartRow + 2] = { hpx: 30 } 
      rowHeights[excelData.length - 1] = { hpx: 20 } 

      LAY_EXCEL.exportExcel(
        excelData,
        `多盟&${companyName}对账单.xlsx`,
        'xlsx',
        {
          extend: {
            '!cols': colWidths,
            '!rows': rowHeights,
            '!merges': merges
          }
        }
      )
    }
  }
}
</script>
<style  lang="scss" scoped>
.exportIcon {
  width: 14px;
  height: 14px;
}
.btn_group .el-button {
  border: none!important;
  margin: 0 15px;
  color: rgba(0,0,0,0.85)!important;
  border-radius: 0!important;
  box-sizing: border-box;
  border-bottom: 2px solid transparent!important;
}
.btn_group  .active_class{
  color: #3361FF!important;
  border-bottom: 2px solid #3361FF!important;
}
.btn_group {
  display: flex;
  justify-content: center;
}
.download {
  padding-top: 10px; 
}
</style>